// Adds an English ordinal suffix
export const withOrdinal = (day) => {
  const rem100 = day % 100;
  if (rem100 >= 11 && rem100 <= 13) return `${day}th`;
  switch (day % 10) {
    case 1: return `${day}st`;
    case 2: return `${day}nd`;
    case 3: return `${day}rd`;
    default: return `${day}th`;
  }
};

export const formatUtcDate = (value) => {
  const raw = String(value).trim();
  const normalized = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw)
    ? raw.replace(' ', 'T')
    : `${raw.replace(' ', 'T')}Z`;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;
  const month = date.toLocaleString('en-US', { month: 'short' });
  return `${month} ${withOrdinal(date.getDate())}, ${date.getFullYear()}`;
};